// Dependencies
import React, { InputHTMLAttributes, useEffect, useState } from 'react'

// Styles
import * as S from './styles'

// Types
interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string
  isActive?: boolean
  subject: 'Linguagens' | 'Natureza' | 'Matemática' | 'Redação'
  className?: string
  changeFunction: Function
}

type OptionProps = {
  values: any[]
  name: string
  className?: string
  label: string
  register: any
  isDisabled?: boolean
  isActive?: boolean
  changeFunction: Function
  clickFunction: Function
}

export const Input = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      isActive = false,
      className,
      subject = 'Linguagens',
      changeFunction,
      name,
      defaultValue = '',
      ...rest
    },
    ref
  ) => {
    const [localValue, setLocalValue] = useState<any>(defaultValue)

    useEffect(() => {
      if (!!defaultValue) {
        setLocalValue(defaultValue)
      }
    })

    function changeMethod(e: any) {
      const aux = parseFloat(e.currentTarget.value)
      if (aux > 1000) setLocalValue(1000)
      else {
        const value = e.target.value
        const rgx = /^[0-9]*\.?[0-9]*$/
        const reg = /^-?\d*(\.\d*)?$/
        if (!isNaN(value) && rgx.test(value)) {
          setLocalValue(e.target.value)
        } else setLocalValue(0)
      }
    }

    return (
      <S.WrapInput isActive={isActive} className={className}>
        <div id="wrapper">
          <label htmlFor={`${name}`} className="texts">
            <p id="subject">{subject}</p>
            <small id="ready">Pronto!</small>
          </label>
          <input
            id={`${name}`}
            onKeyUp={(e) => changeFunction(e)}
            onChange={changeMethod}
            required
            placeholder='000'
            defaultValue={localValue}
            type="text"
            maxLength={6}
            name={name}
            ref={ref}
            {...rest}
          />
        </div>
      </S.WrapInput>
    )
  }
)

const InputDefault = ({
  isActive = false,
  subject = 'Linguagens',
  className,
  name,
  changeFunction,
  value = ''
}: Props) => {
  const [localValue, setLocalValue] = useState<any>(value)

  function changeMethod(e: any) {
    const aux = parseFloat(e.currentTarget.value)
    if (aux > 1000) setLocalValue(1000)
    else {
      const reg = /^-?\d*(\.\d*)?$/
      if (
        (!isNaN(e.target.value) && reg.test(e.target.value)) ||
        e.target.value === ''
      ) {
        setLocalValue(e.target.value)
      }
    }
  }

  return (
    <S.WrapInput isActive={isActive} className={className}>
      <div id="wrapper">
        <label htmlFor={`${name}`} className="texts">
          <p id="subject">{subject}</p>
          <small id="ready">Pronto!</small>
        </label>
        <input
          id={`${name}`}
          onKeyUp={(e) => changeFunction(e)}
          onChange={changeMethod}
          required
          value={localValue}
          type="text"
          maxLength={6}
          name={name}
        />
      </div>
    </S.WrapInput>
  )
}

export const InputOption = ({
  values,
  register,
  label,
  name,
  className,
  isActive = false,
  isDisabled = false,
  changeFunction,
  clickFunction
}: OptionProps) => {
  return (
    <S.SelectOptionWrapper>
      <S.SelectOptionLabel isDisabled={isDisabled}>{label}</S.SelectOptionLabel>

      <S.SelectOption
        isDisabled={isDisabled}
        disabled={isDisabled}
        onClick={() => clickFunction()}
        onChange={(e) => changeFunction(e)}
        ref={register}
        required
        className={className}
        name={name}
      >
        <option value="">Selecione uma opção</option>

        {values.map((val: any) => (
          <option value={val.value} key={val.value}>
            {val.text}
          </option>
        ))}
      </S.SelectOption>
    </S.SelectOptionWrapper>
  )
}

export default InputDefault
